// Photos are optional identity data, never executable/data URLs or credentials.
// Root-relative URLs support future same-origin uploads; OIDC uses HTTPS.
export function safeAccountPhotoUrl(value) {
  if (typeof value !== "string") return null;
  const url = value.trim();
  if (!url || /[\s\\\u0000-\u001f\u007f]/.test(url)) return null;
  if (url.startsWith("/") && !url.startsWith("//")) return url;
  try {
    const parsed = new URL(url);
    return parsed.protocol === "https:" && !parsed.username && !parsed.password
      ? parsed.href : null;
  } catch {
    return null;
  }
}
